<template>
    <div class="normal-invoice">
        <div class="card-header">
            <div class="title">
                <span v-if="form.typ === 1">INVOICE</span>
                <span v-else>發票開立</span>
            </div>
            <div class="actions">
                <!-- 編輯發票資訊按鈕 -->
                <el-button v-if="isEditable" size="mini" @click="startFooChange">編輯發票資訊</el-button>

                <span v-if="isShowDiscountButton">
                    <!-- 銷貨折讓按鈕 -->
                    <template v-if="form.typ !== 1">
                        <span v-if="isEnableDiscountButton" style="margin-left: 10px;">
                            <el-button size="mini" @click="openDiscount">銷貨折讓</el-button>
                        </span>
                        <span v-else style="margin-left: 10px;">
                            <el-tooltip content="您無操作銷貨折讓權限，請聯絡財務人員。" placement="top">
                                <el-button disabled size="mini">銷貨折讓</el-button>
                            </el-tooltip>
                        </span>
                    </template>
                    <!-- 作廢按鈕 -->
                    <span v-if="isEnableDiscountButton" style="margin-left: 10px;">
                        <span v-if="isDeleteDateValidate">
                            <template v-if="form.declared && !form.foO_DIS"> <!-- 已申報、未折讓 -->
                                <el-tooltip :content="`此發票已申報於 ${getPeriodText(form.prefiX_YER, form.prefiX_MONTH)} ，不可作廢。`" placement="top">
                                    <el-button size="mini" disabled>作廢</el-button>
                                </el-tooltip>
                            </template>
                            <template v-else>
                                <el-button size="mini" @click="openVoid">作廢</el-button>
                            </template>
                        </span>
                        <span v-else>
                            <el-tooltip content="已超過此發票可作廢的日期。" placement="top">
                                <el-button disabled size="mini">作廢</el-button>
                            </el-tooltip>
                        </span>
                    </span>
                    <span v-else style="margin-left: 10px;">
                        <el-tooltip content="您無操作作廢權限，請聯絡財務人員。" placement="top">
                            <el-button disabled size="mini">作廢</el-button>
                        </el-tooltip>
                    </span>
                </span>
            </div>
        </div>
        <div class="card-body">
            <el-row :gutter="40" v-if="!isShowFooEditer">
                <el-col :sm="14">
                    <spec-view>
                        <spec-item :label="form.typ === 1 ? '自訂單號' : '發票號碼'">
                            <ahReceiptNumber :v="form.foo" />
                            <ahInvoiceNumberChecker :key="form.foo" :checkNumber="form.foo" :checkDate="form.foO_DAT" :ioo="form.ioo" />
                        </spec-item>
                        <spec-item :label="form.typ === 1 ? 'INVOICE日期' : '發票日期'">
                            {{ form.foO_DAT | dateFormater("YYYY-MM-dd") }}
                        </spec-item>
                        <spec-item label="買受人統編">
                            {{ form.bsn }}
                        </spec-item>
                        <spec-item v-if="form.cny !== 'TWD'" label="匯率">
                            {{ form.rat }}
                        </spec-item>
                        <spec-item v-if="form.cny !== 'TWD'" label="約當台幣">
                            <Money :v="form.amt * form.rat" round />
                            <span style="margin-left: 10px">TWD</span>
                        </spec-item>
                        <spec-item label="開立備註">
                            {{ form.comment }}
                        </spec-item>
                    </spec-view>
                </el-col>
                <el-col :sm="10">
                    <spec-view>
                        <spec-item label="開立人">
                            {{ form.foO_CRT_NAM }}
                        </spec-item>
                        <spec-item label="填寫日期">
                            {{ form.foO_CRT_DAT | dateFormater("YYYY-MM-dd") }}
                        </spec-item>
                        <spec-item label="營業稅申報" v-if="is401Avaliable && !form.foO_DIS_CNL">
                            <el-tag v-if="form.declared" type="success" size="small">
                                <i class="el-icon-check" />
                                已申報
                                {{ getPeriodText(form.prefiX_YER, form.prefiX_MONTH) }}
                            </el-tag>
                            <span v-else>(未申報)</span>
                        </spec-item>
                    </spec-view>
                </el-col>
            </el-row>
            <div v-if="isShowFooEditer">
                <el-form :model="fooChangeForm" :rules="editRules" ref="fooChangeForm" label-position="left" label-width="120px" size="small">
                    <el-form-item
                        v-if="form.typ === 1"
                        label="自訂單號"
                        prop="foo"
                        :rules="[
                            {
                                required: true,
                                message: '請填寫自訂單號',
                                trigger: 'blur'
                            }
                        ]"
                    >
                        <el-input v-model="fooChangeForm.foo" :maxlength="20" show-word-limit style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item v-else prop="foo" label="發票號碼" required>
                        <ahElInputInvoice v-model="fooChangeForm.foo" :key="fooChangeForm.foO_DAT" show-duplicate-hint :check-date="fooChangeForm.foO_DAT" :ioo="form.ioo" :disabled="form.declared" />
                    </el-form-item>
                    <el-form-item prop="foO_DAT" :label="form.typ === 1 ? 'INVOICE日期' : '發票日期'">
                        <div>
                            <el-date-picker v-model="fooChangeForm.foO_DAT" type="date" value-format="timestamp" size="small" :disabled="form.declared" />
                        </div>
                        <div>
                            <el-alert v-if="isFutureInvoiceDate" type="warning" size="small" :closable="false" class="future-invoice-alert">
                                開立發票相關規定請至 財政部（<a href="https://law-out.mof.gov.tw/LawContent.aspx?id=FL006084" target="_blank"> 連結 </a>）查詢
                            </el-alert>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="form.cny !== 'TWD'" prop="rat" label="匯率">
                        <MoneyInput v-model="fooChangeForm.rat" :precision="4" size="small" style="width: 120px" />
                    </el-form-item>
                    <el-form-item v-if="form.cny !== 'TWD'" label="含稅總計">
                        <money-input :value="form.amt" :disabled="true" size="small" style="max-width: 200px; margin-right: 10px" />
                        <ah-el-select-cny :value="form.cny" :disabled="true" />
                    </el-form-item>
                    <el-form-item v-if="form.cny !== 'TWD'" label="約當台幣">
                        <money-input :value="form.amt * fooChangeForm.rat" :disabled="true" size="small" style="max-width: 200px; margin-right: 10px" />
                        <ah-el-select-cny value="TWD" :disabled="true" />
                    </el-form-item>
                    <el-form-item prop="comment" label="開立備註">
                        <el-input v-model="fooChangeForm.comment" type="textarea" :rows="3" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-alert
                            v-if="form.declared"
                            style="line-height: 120%; margin-bottom: 20px;"
                            type="warning"
                            :title="`此發票已申報於 ${getPeriodText(form.prefiX_YER, form.prefiX_MONTH)} ，不可編輯發票號碼、開立日期。`"
                            :closable="false"
                        />
                        <el-button type="primary" size="small" class="primary-action" @click="submitFooChange">
                            儲存
                        </el-button>
                        <el-button size="small" @click="cancelFooChange"> 取消 </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import ahElInputInvoice from '@/components/ui/ahElInputInvoice.vue';
import ahInvoiceNumberChecker from '@/components/ui/ahInvoiceNumberChecker.vue';
import SpecView from '@/components/ui/SpecView/SpecView.vue';
import SpecItem from '@/components/ui/SpecView/SpecItem.vue';
import MoneyInput from '@/components/ui/MoneyInput.vue';
import ahElSelectCny from '@/components/ui/ahElSelectCny.vue';
import ahReceiptNumber from '@/components/ui/ahReceiptNumber.vue';
import invoiceSerialNumber from '@/assets/commonData/invoiceSerialNumber';

export default {
    props: {
        form: {
            type: Object,
            default: () => {},
        },
        isDeleteDateValidate: Boolean,
    },
    components: {
        ahInvoiceNumberChecker,
        ahReceiptNumber,
        ahElInputInvoice,
        SpecView,
        SpecItem,
        MoneyInput,
        ahElSelectCny,
    },
    data() {
        const invoiceValidate = (rule, value, callback) => {
            if (!value) callback(new Error('請填寫發票號碼'));
            else if (value.length < 10) callback(new Error('請輸入完整發票號碼'));
            callback();
        };

        return {
            isShowFooEditer: false,
            fooChangeForm: {
                foo: null,
                foO_DAT: null,
                rat: null,
                comment: null,
            },
            editRules: {
                foo: { required: true, validator: invoiceValidate, trigger: 'blur' },
                foO_DAT: { required: true, message: '此欄位為必填' },
                rat: { required: true, message: '此欄位為必填' },
            },
            expireTimeOption: {
                disabledDate(date) {
                    return date.getTime() >= Date.now();
                },
            },
        };
    },
    computed: {
        isEditable() {
            if (!this.isAuthOne(['B02', 'B03'])) return false;
            if (!(this.form.status === 2 || this.form.status === 3)) return false;
            if (this.isShowFooEditer) return false;

            return true;
        },
        isShowDiscountButton() {
            if (!this.form) return false;
            if (this.form.status === 5) return false; // 已撤銷
            if (this.form.foO_DIS_DAT !== null) return false; // 已折讓
            if (this.isShowFooEditer) return false; // 編輯中
            return true;
        },
        isEnableDiscountButton() {
            return this.isAuthOne(['B03']);
        },
        is401Avaliable() {
            if (this.form.foO_CNL && !this.form.foO_DIS_CNL) return false;
            if (this.isAuth('G03') && this.isPayed('G03')) return true;
            return false;
        },
        isFutureInvoiceDate() {
            const TODAY = moment().startOf('day');
            return moment(this.fooChangeForm.foO_DAT).isAfter(TODAY);
        },
    },
    methods: {
        onCollapseChange(open) {
            if (!open) {
                this.cancelFooChange();
            }
        },

        startFooChange() {
            this.fooChangeForm.foo = this.form.foo;
            this.fooChangeForm.foO_DAT = this.form.foO_DAT;
            this.fooChangeForm.rat = this.form.rat;
            this.fooChangeForm.comment = this.form.comment;
            this.isShowFooEditer = true;
        },
        cancelFooChange() {
            this.isShowFooEditer = false;
            this.fooChangeForm.foo = this.form.foo;
            this.fooChangeForm.foO_DAT = this.form.foO_DAT;
            this.fooChangeForm.rat = this.form.rat;
            this.fooChangeForm.comment = this.form.comment;
        },

        formatFoo(foo) {
            if (!foo) return '--';
            return `${foo.slice(0, 2)}-${foo.slice(2)}`;
        },

        openDiscount() {
            this.$emit('openDiscount');
        },

        openVoid() {
            this.$emit('openVoid');
        },

        submitFooChange() {
            this.$refs.fooChangeForm.validate(async (valid) => {
                if (valid) {
                    try {
                        const code = this.getInvoiceValidateCode(this.fooChangeForm);
                        await this.$api({
                            url: '/InvoiceManagemnetPage/UpdateInvoiceSimpleInfo',
                            method: 'post',
                            data: {
                                invoiceSno: this.form.sno,
                                rat: this.fooChangeForm.rat,
                                foo: this.fooChangeForm.foo,
                                foO_DAT: this.fooChangeForm.foO_DAT,
                                comment: this.fooChangeForm.comment,
                                code,
                            },
                        });

                        this.$message.success('發票資訊已儲存。');
                        this.$emit('reload');
                        // this.reload();
                    } finally {
                        this.isShowFooEditer = false;
                    }
                }
            });
        },

        getPeriodText(year, month) {
            const monthList = ['1~2月', '3~4月', '5~6月', '7~8月', '9~10月', '11~12月'];
            if (year > 1911 && month >= 0 && month < 12) {
                return `${year - 1911}年 ${monthList[month - 1]}`;
            }
            return '';
        },

        getInvoiceValidateCode(item) {
            if (!item.foo) return undefined;
            const isIncome = true;
            const fooMonth = moment(item.foO_DAT).month() + 1;
            const fooYear = moment(item.foO_DAT).year();
            const fooKey = `${item.foo[0]}${item.foo[1]}`;
            const TYPE = _.chain(invoiceSerialNumber)
                .filter(['year', fooYear])
                .find((o) => o.month.includes(fooMonth))
                .get('datas')
                .find((o) => o.serialNumbers.includes(fooKey))
                .get('name')
                .value();

            const isCashierTripleInvoice = item.filE_TYP === 10;
            const TYPE_CODE = { A: 1, B: 2, D: 5 };
            if (TYPE) return Number(`${isIncome ? 3 : 2}${isCashierTripleInvoice ? 5 : TYPE_CODE[TYPE]}`);

            return undefined;
        },
    },
};
</script>

<style lang="scss">
.normal-invoice .future-invoice-alert {
    margin-top: 10px;
    line-height: 30px;

    .el-alert__description {
        margin-top: 0;
    }
}
</style>
